<template>
    <div class="DateTimePickerMonth">
        <div class="DateTimePickerMonth__weekday" v-for="weekday in weekdays" v-once>
            <div class="DateTimePickerMonth__weekday_name">
                {{weekday}}
            </div>
        </div>
        <DateTimePickerDay v-for="(day, index) in days" :key="day.date.valueOf()" :day="day" :index="index"/>
    </div>
</template>

<script>
    import { mapState } from 'vuex';
    import DateTimePickerDay from './DateTimePickerDay.vue';

    export default {
        name: 'DateTimePickerMonth',
        components: { DateTimePickerDay },
        computed: {
            ...mapState({
                days: s => s.dateTimePicker.days,
                weekdays: s => s.dateTimePicker.weekdays
            })
        }
    };
</script>


<style>
    .DateTimePickerMonth {
        display: flex;
        flex-wrap: wrap;
        margin-bottom: 15px;
    }

    .DateTimePickerMonth__weekday {
        width: 14.285%;
    }

    .DateTimePickerMonth__weekday_name {
        text-align: center;
        padding: 2px;
        font-size: 1rem;
        color: rgb(66, 66, 66);
    }
</style>



// WEBPACK FOOTER //
// DateTimePickerMonth.vue?7816f7e0